import React from "react";

class NoAccess extends React.Component
{
    render()
    {
        return (
            <div className="text-center mt-5" id='error'>
                <h2>Access Denied</h2>
                <p>You do not have authorization for this application.</p>
                <p>Please contact canopy-support@mit.edu for assistance.</p>
            </div>
        );
    }
}

export default NoAccess;